import { render } from "./Dots.vue?vue&type=template&id=59eeae58"
import script from "./Dots.vue?vue&type=script&lang=js"
export * from "./Dots.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__